import { Slide } from "@mui/material"

const HideOnScroll = ({ direction = 'up', scrollTrigger, children }) => (
  <Slide
    direction={direction}
    in={!scrollTrigger}
    appear={false}
    timeout={350}>
    {children}
  </Slide>
)

export default HideOnScroll
